import { isValidEmail } from '@acceligentllc/shared/utils/email';
import { isValidPhoneNumber } from '@acceligentllc/shared/utils/phone';
import { isValidTextInput } from '@acceligentllc/shared/utils/text';

import { AccountPermissionTemplate } from '@acceligentllc/shared/enums/accountPermissionTemplate';

import type AccountFM from '../Form/formModel';

export function validate(values: AccountFM) {
	const errors: ValidationErrors = {};
	const { user = {} as AccountFM['user'] } = values;

	if (!isValidTextInput(user?.uniqueId ?? null)) {
		errors.uniqueId = 'Unique ID is required';
	}

	if (!isValidTextInput(user?.email ?? null) && !isValidTextInput(values.user?.phoneNumber ?? null)) {
		errors.email = 'Email or mobile phone required';
	}

	if (user?.email && values.user?.email && !isValidEmail(values.user?.email)) {
		errors.email = 'Invalid email address';
	}

	if (user?.phoneNumber && values.user?.phoneNumber) {
		if (!isValidPhoneNumber(values.user?.phoneNumber)) {
			errors.phoneNumber = 'Invalid mobile phone';
		}
	}

	if (!isValidTextInput(user?.firstName ?? null)) {
		errors.firstName = 'First Name is required';
	}

	if (!isValidTextInput(user?.lastName ?? null)) {
		errors.lastName = 'Last Name is Required';
	}

	if (!values.accountTemplateId || values.accountTemplateId === AccountPermissionTemplate.CUSTOM) {
		errors.accountTemplateId = 'Account template is Required';
	}

	if (values.user?.phoneNumber && !values.agreeToSendSms) {
		errors.agreeToSendSms = 'Must confirm that user has consented to receive SMS notifications';
	}

	return errors;
}
